// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__i41_K","selects":"Documents_selects__35Sw_"};